export const TAB_ID = Math.random().toString(36).substring(2);

/**
 * 通过BroadcastChannel广播消息
 * @param key key
 * @param val 值
 * @returns {BroadcastChannel} BroadcastChannel对象
 */
export const emitBroadcast = (event: string, data: any) => {
  const bc = new BroadcastChannel(event); // 创建BroadcastChannel对象
  bc.postMessage(data);
  return bc;
};

/**
 * 监听BroadcastChannel的消息
 * @param {string} key key
 * @param {Function} cb 回调函数
 * @returns {BroadcastChannel} BroadcastChannel对象
 */
export const onBroadcast = (key: string, cb: any) => {
  const bc = new BroadcastChannel(key); // 创建BroadcastChannel对象
  bc.onmessage = event => {
    cb(event.data);
  };

  return bc;
};

/**
 * 监听BroadcastChannel的消息，但只执行一次
 * @param {string} key key
 * @param {Function} cb 回调函数
 * @returns {BroadcastChannel} BroadcastChannel对象
 */
export const onceBroadcast = (key: string, cb: any) => {
  const bc = new BroadcastChannel(key); // 创建BroadcastChannel对象
  bc.onmessage = event => {
    cb(event.data);
    bc.close();
  };
};
